import client from "../api-config";

export function getDashboardStats() {
  return client.get(`/api/dashboard`);
}
